import script from "./EditPaw.vue?vue&type=script&setup=true&lang=js"
export * from "./EditPaw.vue?vue&type=script&setup=true&lang=js"

import "./EditPaw.vue?vue&type=style&index=0&id=586d8c57&lang=scss"

const __exports__ = script;

export default __exports__